// extracted by mini-css-extract-plugin
export var buttonContainer = "_9z-1";
export var fontSizeSelect = "_9z-3";
export var formatSelect = "_9z-2";
export var formats = "_9z-4";
export var hidden = "_9z-5";
export var icon = "_9z-6";
export var select = "_9z-0";